module.exports = __webpack_public_path__ + "static/7-48ad9847c8c7801d1f902876a91cf18e.jpg";